import { Subject } from 'rxjs'
import { RxJS } from './RxJS'
import { NewReport } from '../Types/Types'

const newReportCreatedSubject: Subject<Definable<NewReport>> = new Subject<Definable<NewReport>>()

RxJS.newReportCreated = RxJS.newReportCreated ?? {
    subject: newReportCreatedSubject,
    observable: newReportCreatedSubject.asObservable(),
    announce: (update?: NewReport): void => {
        newReportCreatedSubject.next(update)
    }
}

export const newReportCreated$ = RxJS.newReportCreated
